const $ = jQuery.noConflict()

class DropdownList {
    constructor(listWrapper, listTitle, list) {
        this.listWrapper = listWrapper;
        this.listTitle = listTitle;
        this.list = list;
    }
    init() {
        
        if('ontouchstart' in window || navigator.msMaxTouchPoints) {
            $(this.list).addClass('non-hoverable');
        }
        else {
            $(this.list).addClass('hoverable');
        }
        this.bindEvents();
    }
    bindEvents() {
        $(this.listTitle).on('click', this.toggleList);
    }
    toggleList() {
        const list = $(this).parent();
        if(list.hasClass('open')) {
            list.removeClass('open');
        }
        else {
            list.addClass('open');
        }
    }
}

export default new DropdownList('.blog-intro__list-wrapper', '.list__title', '.list');